<div class="tabs">
    <ul>
        <li (click)="selectTab.emit(title)" *ngFor="let title of titles" [ngClass]="{ active: title == activeTitle }">
            {{ title }}
        </li>
    </ul>
</div>
